/**
 * Animation de confettis pour les gagnants
 * Selon le cahier des charges: "feu d'artifice digital" avec animation festive
 */

export const createConfetti = (count = 150, isMajorPrize = false) => {
  const colors = ['#FFD700', '#DC143C', '#FF69B4', '#228B22', '#1E90FF', '#FF8C00', '#DAA520'];
  const container = document.body;

  // Augmenter pour les gros lots
  if (isMajorPrize) {
    count *= 2;
  }

  for (let i = 0; i < count; i++) {
    const confetti = document.createElement('div');
    confetti.style.cssText = `
      position: fixed;
      width: ${Math.random() * 10 + 5}px;
      height: ${Math.random() * 10 + 5}px;
      background: ${colors[Math.floor(Math.random() * colors.length)]};
      left: ${Math.random() * 100}vw;
      top: -20px;
      opacity: ${Math.random() * 0.5 + 0.5};
      border-radius: ${Math.random() > 0.5 ? '50%' : '0'};
      pointer-events: none;
      z-index: 9999;
      animation: confetti-fall ${Math.random() * 3 + 2}s linear forwards;
    `;

    container.appendChild(confetti);

    // Supprimer après l'animation
    setTimeout(() => confetti.remove(), 5000);
  }

  // Ajouter les coeurs flottants pour les gros lots
  if (isMajorPrize) {
    createFloatingHearts(20);
  }
};

/**
 * Cree des coeurs flottants pour les gros lots (Amitié, Aventure)
 */
const createFloatingHearts = (count) => {
  const hearts = ['❤️', '💕', '💗', '💖', '💝'];
  const container = document.body;

  for (let i = 0; i < count; i++) {
    const heart = document.createElement('div');
    heart.textContent = hearts[Math.floor(Math.random() * hearts.length)];
    heart.style.cssText = `
      position: fixed;
      font-size: ${Math.random() * 30 + 20}px;
      left: ${Math.random() * 100}vw;
      bottom: -50px;
      opacity: 0.7;
      pointer-events: none;
      z-index: 9999;
      animation: heart-float ${Math.random() * 4 + 3}s ease-out forwards;
      animation-delay: ${Math.random() * 2}s;
    `;

    container.appendChild(heart);

    setTimeout(() => heart.remove(), 7000);
  }
};

/**
 * Animation de révélation avec flash
 * Selon le cahier des charges: "pop-up" ou "feu d'artifice digital"
 */
export const createPrizeRevealAnimation = (emotion, prize) => {
  const flash = document.createElement('div');
  flash.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    opacity: 0;
    pointer-events: none;
    z-index: 9998;
    animation: prize-flash 0.5s ease-out;
  `;

  document.body.appendChild(flash);

  setTimeout(() => flash.remove(), 500);

  // Retourner les données pour l'affichage
  return {
    emotion,
    prize,
    message: `Félicitations ! Votre ${emotion} vous offre ${prize} !`
  };
};

// Ajouter les keyframes d'animation si elles n'existent pas
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes confetti-fall {
      0% {
        transform: translateY(0) rotate(0deg);
        opacity: 1;
      }
      100% {
        transform: translateY(100vh) rotate(${Math.random() * 720}deg);
        opacity: 0;
      }
    }

    @keyframes heart-float {
      0% {
        transform: translateY(0) scale(1);
        opacity: 0.7;
      }
      50% {
        transform: translateY(-50vh) scale(1.2);
        opacity: 0.9;
      }
      100% {
        transform: translateY(-100vh) scale(0.8);
        opacity: 0;
      }
    }

    @keyframes prize-flash {
      0% { opacity: 0; }
      50% { opacity: 0.8; }
      100% { opacity: 0; }
    }
  `;
  document.head.appendChild(style);
}

/**
 * Determine si un lot est un "gros lot" nécessitant une animation spéciale
 */
export const isMajorPrize = (prizeType) => {
  const majorPrizes = ['amitie', 'aventure', 'AMITIE', 'AVENTURE', 'Amitié', 'Aventure'];
  return majorPrizes.some(prize => prizeType?.includes(prize));
};

/**
 * Retourne l'émotion associée à un type de lot
 */
export const getEmotionFromPrizeType = (prizeType) => {
  const emotions = {
    'passion': 'Passion',
    'force': 'Force',
    'complicite': 'Complicité',
    'tendresse': 'Tendresse',
    'amitie': 'Amitié',
    'aventure': 'Aventure',
    'PASSION': 'Passion',
    'FORCE': 'Force',
    'COMPLICITE': 'Complicité',
    'TENDRESSE': 'Tendresse',
    'AMITIE': 'Amitié',
    'AVENTURE': 'Aventure'
  };
  return emotions[prizeType] || 'Émotion';
};
